// @ts-ignore — legacy JS modules from common repo
import {addThirdPartyLoad, ignoreChunkFetchFailure, loadChunkWithReload} from '../js/src/utils';
// @ts-ignore
import {initMainHeaderHome} from '../js/src/header-init';
import {initHomeVideo} from '../js/src/home-video';
import {initTabs} from '../js/src/components/tabs';
import {initAnimations} from '../js/src/components/animations';
import {initLazyBackgrounds} from '../js/src/components/lazy-bg';
import '../scss/pages/home1.scss';


initHomeVideo();
initMainHeaderHome({});

// UI-critical: must run immediately so visible sections aren't blank
initTabs();
initAnimations();
initLazyBackgrounds();

addThirdPartyLoad(async () => {
    try {
        await loadChunkWithReload(
            () => import(/* webpackChunkName: "home-deferred" */ '../js/src/home-deferred'),
            'home-deferred',
        );
    } catch (error) {
        ignoreChunkFetchFailure(error);
    }
});
